/* eslint-disable react/prop-types,react/destructuring-assignment */

import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCloudUpload,
  faExpandAlt,
  faImage,
  faTrashAlt,
} from '@fortawesome/free-solid-svg-icons';
import './Upload.scss';
import { Button, CloseButton } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { ModalDialog } from '../ModalDialog/ModalDialog';

const propTypes = {
  title: PropTypes.string,
  name: PropTypes.string,
  register: PropTypes.func,
  src: PropTypes.string,
  srcName: PropTypes.string,
  setIconSrc: PropTypes.func,
};
const defaultProps = {
  title: 'Logo',
  name: 'logo',
  register: (n) => n,
  setIconSrc: (n) => n,
  src: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=',
  srcName: '',
};

export default function UploadImage({
  title,
  name,
  register,
  src,
  srcName,
  setIconSrc,
}) {
  const { setValue } = useForm();
  const [openDialog, setOpenDialog] = useState(false);
  const [showFullViewToggler, setShowFullViewToggler] = useState(false);
  const [showImgBg, setShowImgBg] = useState(true);
  const [showImgPreview, setShowImagePreview] = useState(false);

  useEffect(() => {
    initObj();
  }, [src]);

  const initObj = () => {
    setShowImagePreview(src && src.length > 0 && src.toString() != null);
    setShowFullViewToggler(src && src.length > 0 && src.toString() != null);
  };

  const toggleFullView = (e) => {
    e.preventDefault();
    const expandView = document.getElementById('expanded-view');
    expandView.classList.toggle('d-block');
    setTimeout(() => expandView.classList.toggle('show'), 300);
  };

  const clearImage = (e) => {
    e.preventDefault();
    setShowImagePreview(false);
    setShowFullViewToggler(false);
    setShowImgBg(true);
    if (srcName.length > 0) {
      setValue(srcName, '');
      document.querySelector(`input[type="hidden"][name="${srcName}"]`).value =
        '';
      setIconSrc('');
    }
  };

  const onFileChange = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    if (e.target.files.length === 0) {
      return;
    }
    if (!e.target.files[0].type.startsWith('image/')) {
      setOpenDialog(true);
      return;
    }
    setValue(name, e.target.files);

    if (e.target.value === '') {
      setShowFullViewToggler(false);
      setShowImagePreview(false);
      setShowImgBg(true);
    } else {
      // show fullViewToggler
      setShowFullViewToggler(true);
      setShowImagePreview(true);
      setShowImgBg(false);
    }

    reader.onloadend = () => {
      setIconSrc(reader.result);
    };

    if (file) {
      reader.readAsDataURL(file);
    } else {
      setIconSrc('');
    }
  };

  return (
    <div className="upload-component">
      <div className="header-block">
        <h5 className="m-0 mr-3">{title}</h5>
        {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
        <label htmlFor="file-upload" className="btn btn-link">
          <FontAwesomeIcon icon={faCloudUpload} />
        </label>
        <Button
          variant="link"
          type="button"
          className="clear-image"
          onClick={clearImage}
        >
          <FontAwesomeIcon icon={faTrashAlt} />
        </Button>
      </div>
      <div className="uploader-block position-relative" onChange={onFileChange}>
        <input
          type="file"
          id="file-upload"
          accept="image/*"
          {...register(name)}
        />
        {showImgBg && (
          <span className="d-block bg-image" id="bg-image">
            <FontAwesomeIcon icon={faImage} />
          </span>
        )}
        {showFullViewToggler && (
          <Button
            type="button"
            className="d-block expand-image"
            id="full-view-toggler"
            onClick={toggleFullView}
          >
            <FontAwesomeIcon icon={faExpandAlt} />
          </Button>
        )}
        {showImgPreview && (
          <img id="img-preview" src={src} className="img-preview" alt="" />
        )}
      </div>
      <div id="expanded-view" className="expanded-view fade">
        <img className="full-image" src={src} id="full-image" alt="" />
        <CloseButton type="button" onClick={toggleFullView} />
      </div>
      {srcName.length > 0 && (
        <input
          type="hidden"
          name={srcName}
          value={src}
          {...register(srcName)}
        />
      )}
      <ModalDialog
        open={openDialog}
        setOpen={setOpenDialog}
        header={title}
        message="The selected file is not a valid image file. Please select a valid image file."
        onConfirm={() => setOpenDialog(false)}
        noCancel
      />
    </div>
  );
}
UploadImage.propTypes = propTypes;
UploadImage.defaultProps = defaultProps;
